import { useEffect, useState } from "react";
import { useFirestore, useFirestoreDocData } from "reactfire";
import { doc } from "firebase/firestore";
import { classNames, timeDiffCalc } from "utils/utils";
import { useTranslation } from "react-i18next";

const RoundStatus = ({ leagueData, userRoundData }) => {
  const firestore = useFirestore();
  const [roundData, setRoundData] = useState(undefined);
  const { t } = useTranslation();

  const { gameType, leagueRef, seasonRef, settled } = leagueData;

  const { nextRoundNumber, totalRounds, roundCompleteness, nextRoundItem } =
    calculateStatusData(leagueData?.rounds);

  const roundDataRef = doc(
    firestore,
    "leagues/" + leagueRef + "/seasons/" + seasonRef + "/rounds/",
    nextRoundItem?.id
  );
  const { status: roundDataStatus, data: roundDataDoc } =
    useFirestoreDocData(roundDataRef);
  useEffect(() => {
    if (roundDataDoc) {
      setRoundData(roundDataDoc);
    }
  }, [roundDataDoc]);

  let inProgress = new Date(roundData?.deadline?.seconds * 1000) < new Date();
  let leagueStarted =
    new Date(leagueData?.deadline?.seconds * 1000) < new Date();
  let time = timeDiffCalc(
    new Date(roundData?.deadline?.seconds * 1000),
    new Date().getTime()
  );

  let leagueCompletenessClass;
  let roundCompletenessAdjusted = roundCompleteness;

  if (!inProgress) {
    roundCompletenessAdjusted = 5;
  } else if (roundCompleteness == 100 && !settled) {
    roundCompletenessAdjusted = 95;
  }

  leagueCompletenessClass = `w-[${Math.round(roundCompletenessAdjusted)}%]`;

  return (
    <div className="w-full flex flex-col justify-end h-fit">
      {!userRoundData ? (
        <div className="flex text-sm text-white w-full whitespace-nowrap">
          {!leagueStarted
            ? t("lobby.card.league_starts_in", {
                time: time,
              })
            : t("lobby.card.round_starts_in", {
                round: nextRoundNumber,
                time: time,
              })}
        </div>
      ) : (
        <>
          <div
            className={classNames(
              gameType === 0 && "pb-1",
              "flex w-full space-between"
            )}
          >
            <div className="flex font-ultralight text-xs text-white w-full whitespace-nowrap">
              {inProgress
                ? t("lobby.card.round_in_progress", {
                    round: nextRoundNumber,
                  })
                : t("lobby.card.round_starts_in", {
                    round: nextRoundNumber,
                    time: time,
                  })}
            </div>
            <div className="flex font-ultralight text-xs text-white">
              {gameType === 0 &&
                "(" + nextRoundNumber + "/" + totalRounds + ")"}
            </div>
          </div>
          {gameType === 0 && (
            <div className="w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700">
              <div
                className={classNames(
                  leagueCompletenessClass,
                  "bg-pink-500 h-2 rounded-full"
                )}
              ></div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

function calculateStatusData(rounds) {
  const roundLength = Object.keys(rounds).length;

  let sumOfSettledRounds = 0;
  let firstUnsettledRound = null;

  for (const roundId in rounds) {
    const round = rounds[roundId];
    if (round.settled) {
      sumOfSettledRounds++;
    } else if (
      !firstUnsettledRound ||
      round.sort_order < firstUnsettledRound.sort_order
    ) {
      firstUnsettledRound = round;
    }
  }

  if (sumOfSettledRounds == roundLength) {
    sumOfSettledRounds = sumOfSettledRounds;
  } else {
    sumOfSettledRounds = sumOfSettledRounds + 1;
  }

  return {
    nextRoundNumber: sumOfSettledRounds,
    totalRounds: roundLength,
    roundCompleteness: (sumOfSettledRounds / roundLength) * 100,
    nextRoundItem: firstUnsettledRound,
  };
}

export default RoundStatus;
